import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { HandleError, HttpErrorHandler } from '../../http-error-handler.service';

@Injectable()
export class GeoLocalizacaoService {

  private env = environment;
  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('GeoLocalizacaoService');
  }

  getGeoLocalizacao(endereco, cep = null): Observable<any> {
    if (cep !== null) {
      return this.http
        .get(`${this.env.API_ENDPOINT_GEOLOCALIZACAO.link}/api/geocode/json?address=${endereco}&components=postal_code:${cep}&key=AIzaSyDTlWRVmzua_yzh9m5iUbYkCJyv9ppjKrw`)
        .pipe(
          catchError(this.handleError('Consulta GeoLocalização com CEP', []))
        );
    } else {
      return this.http
        .get(`${this.env.API_ENDPOINT_GEOLOCALIZACAO.link}/api/geocode/json?address=${endereco}&key=AIzaSyDTlWRVmzua_yzh9m5iUbYkCJyv9ppjKrw`)
        .pipe(
          catchError(this.handleError('Consulta GeoLocalização sem CEP', []))
        );
    }
  }

}
